'use client';

import { Tab } from '@common/components';

import type { MedianIncomeYear } from '../constants';
import { MEDIAN_INCOME_YEARS } from '../constants';

interface YearTabsProps {
  selectedYear: MedianIncomeYear;
  onChange: (year: MedianIncomeYear) => void;
}

/**
 * 연도 선택 탭 — `MEDIAN_INCOME_YEARS` 의 키를 순회.
 * 보유 연도가 1개뿐이면 시각적 가치가 없어 숨긴다.
 */
export const YearTabs = ({ selectedYear, onChange }: YearTabsProps) => {
  if (MEDIAN_INCOME_YEARS.length < 2) return null;

  return (
    <Tab<MedianIncomeYear>
      value={selectedYear}
      onChange={onChange}
      variant="flex"
    >
      {MEDIAN_INCOME_YEARS.map((year) => (
        <Tab.Item key={year} value={year}>
          {year}년
        </Tab.Item>
      ))}
    </Tab>
  );
};
